<div class="otp-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Xác nhận OTP</mat-card-title>
      <mat-card-subtitle>Mã OTP đã được gửi đến email của bạn</mat-card-subtitle>
    </mat-card-header>
    
    <mat-card-content>
      <form [formGroup]="otpForm">
        <div class="otp-inputs">
          <mat-form-field *ngFor="let control of otpControls; let i = index">
            <input matInput
                   [formControlName]="'digit' + i"
                   maxlength="1"
                   (keyup)="onOtpInput($event, i)"
                   (keydown)="onKeyDown($event, i)"
                   #otpInput>
          </mat-form-field>
        </div>
        
        <div class="timer" *ngIf="timeLeft > 0">
          Mã OTP có hiệu lực trong: {{timeLeft}} giây
        </div>
        
        <div class="resend" *ngIf="timeLeft === 0">
          <button mat-button color="primary" (click)="resendOTP()">
            Gửi lại mã OTP
          </button>
        </div>
      </form>
    </mat-card-content>

    <mat-card-actions>
      <button mat-raised-button color="primary" 
              [disabled]="!otpForm.valid || isLoading"
              (click)="confirmOTP()">
        Xác nhận
      </button>
      <button mat-button (click)="cancel()">Hủy</button>
    </mat-card-actions>
  </mat-card>
</div>
